import React from "react";
import { useWatch } from "react-hook-form";
import { RadioButtonGroup } from "./RadioButtonGroup.jsx";

export function MaxElectricInput({
  name,
  maxElectricFilters,
  formContext,
  ...rest
}) {
  const {
    control,
    setValue,
    formState: { isDirty },
  } = formContext;

  const selectedFilters = useWatch({ name: "selectedFilters", control });

  const hasElectric = selectedFilters.find(
    (filter) => filter === "hasElectric",
  );

  // Reset maxElectric if hasElectric changes
  React.useEffect(() => {
    if (isDirty && !hasElectric) {
      setValue("maxElectric", "");
    }
  }, [hasElectric]);

  if (!hasElectric) {
    return null;
  }

  // Hide if no amperage options available (e.g., agency doesn't track amperage)
  if (!maxElectricFilters || maxElectricFilters.length === 0) {
    return null;
  }

  return (
    <RadioButtonGroup
      control={control}
      name={name}
      label="What hookup do you need?"
      options={maxElectricFilters}
      size="sm"
      {...rest}
    />
  );
}
